import React from 'react';
import styled from 'styled-components';

// Create a Wrapper component that'll render a <section> tag with some styles
const StyledBorders = styled.div`
  padding-left: 150px;
  padding-right: 150px;
  height: max-content;

  @media (max-width: 1023px) {
    padding-left: 50px;
    padding-right: 50px;
  }
  @media (max-width: 600px) {
    padding-left: 15px;
    padding-right: 15px;
  } 
  @media (max-width: 480px) {
    padding-left: 7px;
    padding-right: 7px;
  }
`;

const Borders = (props) => (<StyledBorders>{props.children}</StyledBorders>);

export default Borders;


// WEBPACK FOOTER //
// ./src/Containers/Borders.js